import React from "react";
import LandscapeIcon from "@mui/icons-material/Landscape";

//Types
import { SvgIconProps } from "@mui/material";

function ZasticenoPodrucjeIcon(props: SvgIconProps) {
  return <LandscapeIcon {...props}/>;
}

export default ZasticenoPodrucjeIcon;
